import { createFileRoute } from "@tanstack/react-router";
import { BlackfeoCatalogoPage } from "@/components/blackfeo/BlackfeoCatalogoPage";

const URL = "https://fisioemortopedia.com.br/blackfeo";
const T = "BLACKFEO · Todos os produtos com até 80% OFF | FEO";
const D = "BLACKFEO da Fisio em Ortopedia: pós-graduações, certificações, STAR Cursos e Agente IA com até 80% de desconto, de 3 a 30 de novembro.";

export const Route = createFileRoute("/blackfeo")({
  validateSearch: (s: Record<string, unknown>): { preview?: boolean } =>
    s.preview === "1" || s.preview === 1 || s.preview === true ? { preview: true } : {},
  head: () => ({
    meta: [
      { title: T },
      { name: "description", content: D },
      { name: "robots", content: "noindex, follow" },
      { property: "og:title", content: T },
      { property: "og:description", content: D },
      { property: "og:type", content: "website" },
      { property: "og:url", content: URL },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: T },
      { name: "twitter:description", content: D },
    ],
    links: [{ rel: "canonical", href: URL }],
  }),
  component: () => <BlackfeoCatalogoPage preview={Route.useSearch().preview === true} />,
});
